import HomeStorySection from './HomeStorySection';
import HomeHowItWorksSection from './HomeHowItWorksSection';
import HomeWhyCoownSection from './HomeWhyCoownSection';
import HomeServicesSection from './HomeServicesSection';
import HomeJourneyCtaSection from './HomeJourneyCtaSection';

const HomeMarketingSections = ({ setPage, onViewListings, isLoggedIn }) => (
  <div className="home-marketing">
    <HomeHowItWorksSection />
    <HomeWhyCoownSection />

    <HomeStorySection />

    <HomeServicesSection setPage={setPage} onViewListings={onViewListings} isLoggedIn={isLoggedIn} />

    <HomeJourneyCtaSection setPage={setPage} isLoggedIn={isLoggedIn} />
  </div>
);

export default HomeMarketingSections;
